(ns dashboard.components.button
  (:require
   [reagent.core :as reagent]
   [re-frame.core :as re-frame]
   [dashboard.utils :refer [cs href]]
   [headlessui-reagent.core :as ui]))

(defn button
  [{:keys [right-icon left-icon on-click class intent type small?]
    :or {type "button"
         small? false}} & children]
  [:button.border.rounded-md.shadow-sm.inline-flex.justify-center.text-sm.font-medium.focus:outline-none.focus:ring-2.focus:ring-offset-2
   {:type type
    :class (cs ""
               (when (some? class) class)
               (if small? "py-1 px-2.5" "py-2 px-4")
               (cond
                 (= intent :intent/primary)
                 "bg-primary-500 hover:bg-primary-700 focus:ring-primary-500 text-white border-transparent"

                 (= intent :intent/danger)
                 "bg-red-500 hover:bg-red-700 focus:ring-red-500 text-white border-transparent"

                 (= intent :intent/default)
                 "bg-white hover:bg-gray-50 focus:ring-red-500 text-gray-700 border-gray-300"

                 :else "bg-primary-500 hover:bg-primary-700 focus:ring-primary-500 border-transparent text-white"))
    :on-click on-click}
   (when (some? left-icon)
     left-icon)
   `[:span
     ~@children]
   (when (some? right-icon)
     right-icon)])

(defn button-group
  [{:keys [buttons]
    :or {buttons []}}]
  [:span.relative.z-0.inline-flex.shadow-sm.rounded-m
   (doall
    (for [button buttons]
      ^{:key (:id button)}
      [:button.-ml-px.first:ml-0.relative.inline-flex.items-center.px-4.py-2.first:rounded-l-md.last:rounded-r-md.border.border-gray-300.text-sm.font-medium.focus:z-10.focus:outline-none.focus:ring-1.focus:ring-primary-500.focus:border-primary-500
       {:type "button"
        :class (cs ""
                   (if (:active? button)
                     "bg-primary-500 text-white hover:bg-primary-700"
                     "bg-white text-gray-700 hover:bg-gray-50"))
        :on-click (:on-click button)}
       (:content button)]))])

(defn dropdown-button
  [{:keys [right-icon left-icon actions class intent small?]} & children]
  [ui/menu
   {:as "div"
    :class "relative inline-block text-left"}
   [ui/menu-button
    {:class (cs "border border-transparent rounded-md shadow-sm inline-flex justify-center text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2"
                (when (some? class) class)
                (if small? "py-1 px-2.5" "py-2 px-4")
                (cond
                  (= intent :intent/primary)
                  "bg-primary-500 hover:bg-primary-700 focus:ring-primary-500"

                  (= intent :intent/danger)
                  "bg-red-500 hover:bg-red-700 focus:ring-red-500"

                  (= intent :intent/default)
                  "bg-white hover:bg-gray-50 focus:ring-red-500 text-gray-700 border-gray-300"

                  :else "bg-primary-500 hover:bg-primary-700 focus:ring-primary-500"))}
    `[:span
      ~@children]
    (when (some? left-icon)
      left-icon)
    (when (some? right-icon)
      right-icon)]
   [ui/transition
    {:class "relative z-50"
     :enter "transition ease-out duration-200"
     :enter-from "transform opacity-0 scale-95"
     :enter-to "transform opacity-100 scale-100"
     :leave "transition ease-in duration-75"
     :leave-from "transform opacity-100 scale-100"
     :leave-to "transform opacity-0 scale-95"}
    [ui/menu-items
     {:class "focus:outline-none absolute right-0 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 z-50"}
     [:div.px-1.py-1
      (doall
       (for [action actions]
         ^{:key (:id action)}
         [ui/menu-item
          (fn [{:keys [active]}]
            [:a
             {:class (cs "group flex px-4 py-2 text-sm rounded-md"
                         (if active
                           "bg-primary-500 text-white"
                           "text-black"))
              :href (when (some? (:href action)) (href (:href action)))
              :on-click (:on-click action)}
             (when (some? (:icon action))
               (:icon action))
             (:name action)])]))]]]])

(defn switch-buttons
  [{:keys [content-left content-right on-click-right on-click-left active-side class]
    :or {active-side :left}}]
  [:div.group.rounded-lg.flex.bg-gray-100.hover:bg-gray-200
   {:class (cs "p-0.5"
               (when (some? class) class))}
   [:button.rounded-md.flex.items-center.text-sm.text-gray-600.font-medium.focus-visible:ring-2.focus-visible:ring-primary-500.focus-visible:ring-offset-2.focus:outline-none.focus-visible:ring-offset-gray-100
    {:on-click on-click-left
     :class (cs ""
                (if (= active-side :left)
                  "bg-white shadow-sm ring-1 ring-black ring-opacity-5 ease-in duration-200"
                  "ease-out duration-200"))}
    [:span.text-gray-600.group-hover:text-gray-900
     {:class (cs "ml-0.5 p-1.5 lg:pl-2.5 lg:pr-3.5"
                 (if (= active-side :left)
                   "text-gray-900"
                   "text-gray-600 group-hover:text-gray-900"))}
     content-left]]
   [:button.rounded-md.flex.items-center.text-sm.text-gray-600.font-medium.focus-visible:ring-2.focus-visible:ring-primary-500.focus-visible:ring-offset-2.focus:outline-none.focus-visible:ring-offset-gray-100
    {:on-click on-click-right
     :class (cs ""
                (if (= active-side :right)
                  "bg-white shadow-sm ring-1 ring-black ring-opacity-5 ease-in duration-200"
                  "ease-out duration-200"))}
    [:span.text-gray-600.group-hover:text-gray-900
     {:class (cs "ml-0.5 p-1.5 lg:pl-2.5 lg:pr-3.5"
                 (if (= active-side :right)
                   "text-gray-900"
                   "text-gray-600 group-hover:text-gray-900"))}
     content-right]]])
